// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__4GHfC","row":"styles_row__nfqNc"};